import React from 'react';
import classnames from 'classnames';
import Carousel from 'react-slick';
import ReputationChart from 'common/components/reputation_chart';
import Avatar from 'common/components/avatar';

/**
 * 'Work With' brief section for 1-1 projects.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const WorkWith = ({user, project}) => {

  /* if no creative has been selected yet, this section doesn't make sense */
  if (!project.one_to_one_creative) return null

  /* since 1-1 projects are not public, the user can only be
     - the owner
     - a collaborator
     - the selected creative */
  const isCreative = project.one_to_one_creative === user.id

  const reputationLabel = (project.one_to_one_creative_is_elite?
    'Elite':
    (project.one_to_one_creative_is_platinum? 'Platinum':'')
  )

  return (
    <section className="row work-with">
      <div className="large-4 columns brief-title">
        <h2>Working With</h2>
      </div>

      {isCreative?
      <div className="small-16 large-5 columns brief-content">
        <div className="row">
          <div className="columns small-4">
            <Avatar
              user={{
                avatar: project.client_avatar, first_name: project.client_first_name,
                last_name: project.client_last_name, username: project.client_username
              }}
              extraClasses="avatar-md avatar-shadow"
            />
          </div>
          <div className="columns small-12">
            <h4 className="username">{project.client_username}</h4>
            <div className="location">{project.client_country_full_name}</div>
          </div>
        </div>
      </div>:
      <div className="small-16 large-5 columns brief-content">
        <div className="row columns">
          <Avatar
            user={{
              avatar: project.one_to_one_creative_avatar,
              first_name: project.one_to_one_creative_first_name,
              last_name: project.one_to_one_creative_last_name,
              username: project.one_to_one_creative_username
            }}
            extraClasses="avatar-md avatar-shadow"
          />
          <div className="user-meta">
            <h4 className="username">{project.one_to_one_creative_username}</h4>
            <div className="location">{project.one_to_one_creative_country_full_name}</div>
          </div>
          <ReputationChart
            containerClass="reputation"
            reputation={parseInt(project.one_to_one_creative_reputation)}
          />
          {reputationLabel &&
          <div className={classnames("tag tag-sm tag-highlight", {
              "platinum": project.one_to_one_creative_is_platinum,
              "elite": project.one_to_one_creative_is_elite
          })}>
          {reputationLabel}
          </div>
          }
        </div>
      </div>}

    </section>
  )
}

export default WorkWith;



// WEBPACK FOOTER //
// ./project/components/brief/work_with_1_1.jsx